import React from 'react'
import { Filters } from './Filters/Filters'
import { SearchInput } from './SearchInput/SearchInput'
import { createTheme, Skeleton, ThemeProvider } from '@mui/material'
import { muiTheme } from '../../Mui/Configuration/Theme'

const component = 'jobs-search'

export function JobsSearch() {
    const theme = createTheme(muiTheme)
    return (
        <ThemeProvider theme={theme}>
            <SearchInput />
            <Filters />
        </ThemeProvider>
    )
}
